"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MobileBottomNavigation = _interopRequireDefault(require("./MobileBottomNavigation"));

var _headerContext = require("./headerContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MobileBottomContent(_ref) {
  var onClickCategories = _ref.onClickCategories,
      onClickHome = _ref.onClickHome,
      hasCategories = _ref.hasCategories;
  return /*#__PURE__*/_react.default.createElement(_headerContext.HeaderContext.Consumer, null, function (_ref2) {
    var state = _ref2.state;

    if (state.searching) {
      return null;
    }

    return /*#__PURE__*/_react.default.createElement(_MobileBottomNavigation.default, {
      onClickCategories: onClickCategories,
      hasCategories: hasCategories,
      onClickHome: onClickHome
    });
  });
}

MobileBottomContent.propTypes = {
  onClickHome: _propTypes.default.func.isRequired,
  onClickCategories: _propTypes.default.func.isRequired,
  hasCategories: _propTypes.default.bool
};
MobileBottomContent.defaultProps = {
  hasCategories: false
};
var _default = MobileBottomContent;
exports.default = _default;